import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./tooltip";
import "./slider.css";

const Slider = ({
  label,
  value,
  hideValue = false,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  info,
  levelCap,
  disabled = false,
  levelCapIndicator,
}) => {
  const handleChange = (e) => {
    const newValue = parseFloat(e.target.value);
    onChange(newValue);
  };

  // Calculate percentages for the gradient
  const progressPercent = ((value - min) / (max - min)) * 100;
  const maxAllowedPercent = levelCap
    ? ((levelCap - min) / (max - min)) * 100
    : 100;

  // Calculate the background gradient
  const getBackground = () => {
    const activeColor = "#3b47d1"; // Slightly darker blue
    const disabledColor = "#d1d5db"; // Light gray for disabled portion
    const maxReachedColor = "#edf0f5"; // Even lighter gray for portion beyond max

    if (!levelCap) {
      return `linear-gradient(to right, 
        ${activeColor} 0%, 
        ${activeColor} ${progressPercent}%, 
        ${disabledColor} ${progressPercent}%, 
        ${disabledColor} 100%)`;
    }

    return `linear-gradient(to right, 
      ${activeColor} 0%, 
      ${activeColor} ${progressPercent}%, 
      ${disabledColor} ${progressPercent}%, 
      ${disabledColor} ${maxAllowedPercent}%,
      ${maxReachedColor} ${maxAllowedPercent}%, 
      ${maxReachedColor} 100%)`;
  };

  return (
    <div className="slider-container">
      <div className="slider-label">
        <label>
          {label} {!hideValue && `(${value}%)`}
        </label>

        {levelCapIndicator && (
          <span className="level-cap-indicator">{levelCapIndicator}</span>
        )}

        {info && (
          <TooltipProvider>
            <Tooltip>
              <TooltipTrigger>
                <Info size={20} className="info-icon" />
              </TooltipTrigger>
              <TooltipContent>
                <p>{info}</p>
              </TooltipContent>
            </Tooltip>
          </TooltipProvider>
        )}
      </div>

      <div className="slider-control">
        <div className="range-container">
          <input
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={handleChange}
            className="range-input"
            style={{
              background: getBackground(),
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Slider;
